import React from 'react'
import JiaMengHeader from '@components/JiaMeng/Header/InsertCustomer'
import InsertCustomer from '@components/JiaMeng/InsertCustomer'

export default {
  path: 'insertCustomer',
  component: props => <JiaMengHeader key="insertCustomer" {...props} />,
  indexRoute: {
    component: InsertCustomer
  },
  stat: '加盟店客资/首页'
}
